import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-top-small"} maskId="square-filled-radius-0-stroke-1-IconChevronTopSmall"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 9.29297L16.7072 14.0001L16.0001 14.7072L12.0001 10.7072L8.00008 14.7072L7.29297 14.0001L12.0001 9.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTopSmall;
